module.exports = __webpack_public_path__ + "aa0ac971fa9f947c423f811548231b66.jpg";